import Agreements from "./Agreements";
import AgreementsAdd from "./AgreementsAdd";
import CarAdd from "./CarAdd";
import ClaimAmount from "./ClaimAmount";
import CommissionRules from "./CommissionRules";
import CommissionSheets from "./CommissionSheets";
import CoveredParts from "./CoveredParts";
import CoverTypes from "./CoverTypes";
import CustomPricing from "./CustomPricing";
import Duration from "./Duration";
import Forgotpassword from "./Forgotpassword";
import Home from "./Home";
import Invoices from "./Invoices";
import Login from "./Login";
import Manage from "./Manage";
import ManageCar from "./ManageCar";
import ManageGroups from "./ManageGroups";
import ManageUsers from "./ManageUsers";
import PaymentsOut from "./PaymentsOut";
import PaymentsReceived from "./PaymentsReceived";
import PermissionProfiles from "./PermissionProfiles";
import Policies from "./Policies";
import Pricing from "./Pricing";
import Refund from "./Refund";
import Return from "./Return";
import Schedule from "./Schedule";
import Statements from "./Statements";
import Status from "./Status";
import UserAdd from "./UserAdd";
import Vat from "./Vat";
import Guarantee from "./Guarantee";
import VehicleDetails from "./VehicleDetails";
import Documents from "./Documents";
import Claims from "./Claims";
import ClaimView from "./ClaimView";
import ScheduleAdd from "./ScheduleAdd";
import PricingView from "./PricingView";
import CustomPricingRules from "./CustomPricingRules";
import CustomPricingRulesView from "./CustomPricingRulesView";
import NotFound from "./NotFound";
import PermissionManage from "./PermissionManage";
import PolicieAdd from "./PolicieAdd";
import ClaimLimits from "./ClaimLimits";
import DurationManage from "./DurationManage";
import ClaimLimitsManage from "./ClaimLimitsManage";
import CoverTypesManage from "./CoverTypesManage";
import ClaimViewStepParts from "./ClaimViewStepParts";
import GroupView from "./GroupView";
import PaymentsOutView from "./PaymentsOutView";
import PaymentsReceivedView from "./PaymentsReceivedView";
import Resetpassword from "./Resetpassword";
import CommissionRulesView from "./CommissionRulesView";

export const publicRoute = [
  {
    path: "/",
    element: <Login />,
    title: "login",
  },
  {
    path: "/forgotpassword",
    element: <Forgotpassword />,
    title: "forgotpassword",
  },
  {
    path: "/resetpassword",
    element: <Resetpassword />,
    title: "resetpassword",
  },
  {
    path: "*",
    element: <NotFound />,
    title: "notfound",
  },
];

export const privateRoute = [
  {
    path: "/home",
    element: <Home />,
    title: "home",
  },
  // {
  //   path: "/accounts",
  //   element: <Accounts />,
  //   title: "accounts",
  // },
  {
    path: "/status",
    element: <Status />,
    title: "status",
  },
  {
    path: "/managecar",
    element: <ManageCar />,
    title: "managecar",
  },
  {
    path: "/caradd",
    element: <CarAdd />,
    title: "caradd",
  },
  {
    path: "/manage",
    element: <Manage />,
    title: "manage",
  },
  {
    path: "/manageusers",
    element: <ManageUsers />,
    title: "manageusers",
  },
  {
    path: "/useradd",
    element: <UserAdd />,
    title: "useradd",
  },
  {
    path: "/claimamount",
    element: <ClaimAmount />,
    title: "claimamount",
  },
  {
    path: "/commissionrules",
    element: <CommissionRules />,
    title: "CommissionRules",
  },
  {
    path: "/commissionrulesview",
    element: <CommissionRulesView />,
    title: "commissionrulesview",
  },
  {
    path: "/commissionsheets",
    element: <CommissionSheets />,
    title: "commissionsheets",
  },
  {
    path: "/covertypes",
    element: <CoverTypes />,
    title: "covertypes",
  },
  {
    path: "/duration",
    element: <Duration />,
    title: "duration",
  },
  {
    path: "/managegroups",
    element: <ManageGroups />,
    title: "managegroups",
  },
  {
    path: "/groupview",
    element: <GroupView />,
    title: "groupview",
  },
  {
    path: "/paymentsout",
    element: <PaymentsOut />,
    title: "paymentsout",
  },
  {
    path: "/paymentsoutview",
    element: <PaymentsOutView />,
    title: "paymentsoutview",
  },
  {
    path: "/paymentsReceived",
    element: <PaymentsReceived />,
    title: "paymentsReceived",
  },
  {
    path: "/paymentsreceivedview",
    element: <PaymentsReceivedView />,
    title: "paymentsreceivedview",
  },

  {
    path: "/permissionprofiles",
    element: <PermissionProfiles />,
    title: "permissionprofiles",
  },
  {
    path: "/pricing",
    element: <Pricing />,
    title: "pricing",
  },
  {
    path: "/pricingview",
    element: <PricingView />,
    title: "pricingview",
  },
  {
    path: "/refund",
    element: <Refund />,
    title: "refund",
  },
  {
    path: "/return",
    element: <Return />,
    title: "return",
  },
  {
    path: "/schedule",
    element: <Schedule />,
    title: "schedule",
  },
  {
    path: "/scheduleadd",
    element: <ScheduleAdd />,
    title: "scheduleadd",
  },
  {
    path: "/coveredparts",
    element: <CoveredParts />,
    title: "coveredparts",
  },
  {
    path: "/vat",
    element: <Vat />,
    title: "vat",
  },
  {
    path: "/policies",
    element: <Policies />,
    title: "policies",
  },
  {
    path: "/custompricing",
    element: <CustomPricing />,
    title: "custompricing",
  },
  {
    path: "/custompricingrules",
    element: <CustomPricingRules />,
    title: "custompricingrules",
  },
  {
    path: "/custompricingrulesview",
    element: <CustomPricingRulesView />,
    title: "custompricingrulesview",
  },
  {
    path: "/statements",
    element: <Statements />,
    title: "statements",
  },
  {
    path: "/agreements",
    element: <Agreements />,
    title: "agreements",
  },
  {
    path: "/invoices",
    element: <Invoices />,
    title: "invoices",
  },
  {
    path: "/agreementsadd",
    element: <AgreementsAdd />,
    title: "agreementsadd",
  },
  {
    path: "/vehicledetails",
    element: <VehicleDetails />,
    title: "vehicledetails",
  },
  {
    path: "/guarantee",
    element: <Guarantee />,
    title: "guarantee",
  },
  {
    path: "/documents",
    element: <Documents />,
    title: "Documents",
  },
  {
    path: "/claims",
    element: <Claims />,
    title: "claims",
  },
  {
    path: "/claimview",
    element: <ClaimView />,
    title: "claimview",
  },
  {
    path: "/permissionmanage",
    element: <PermissionManage />,
    title: "permissionmanage",
  },
  {
    path: "/policieadd",
    element: <PolicieAdd />,
    title: "policieadd",
  },
  {
    path: "/claimlimits",
    element: <ClaimLimits />,
    title: "claimlimits",
  },
  {
    path: "/durationmanage",
    element: <DurationManage />,
    title: "durationmanage",
  },
  {
    path: "/claimlimitsmanage",
    element: <ClaimLimitsManage />,
    title: "claimlimitsmanage",
  },
  {
    path: "/covertypesmanage",
    element: <CoverTypesManage />,
    title: "covertypesmanage",
  },
  {
    path: "/claimviewstepparts",
    element: <ClaimViewStepParts />,
    title: "claimviewstepparts",
  },
  {
    path: "*",
    element: <NotFound />,
    title: "notfound",
  },
];
